export class BusinessOpeningHours {
    public remarks?: string;
    public schedule?: any;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }

    public clone(): BusinessOpeningHours {
        const businessOpeningHours = new BusinessOpeningHours();

        businessOpeningHours.remarks = this.remarks;
        businessOpeningHours.schedule = this.schedule ? JSON.parse(JSON.stringify(this.schedule)) : null;

        return businessOpeningHours;
    }
}
